var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonYellowLeftLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 56,
    viewBox: "0 0 15 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8462 47.9887C8.1732 49.7272 8.1305 52.0603 8.0316 53.7601C7.962 54.9549 8.8975 55.9998 10.0943 55.9998H15V0H10.0943C8.8975 0 7.962 1.0448 8.0316 2.2396C8.1305 3.9395 8.1732 6.2726 7.8462 8.0111C7.602 9.3095 7.4274 10.04 6.9632 11.2777C6.1505 13.4453 4.1042 14.1006 3.9902 16.411C3.8985 18.2686 5.5255 20.9221 5.5255 20.9221C5.5255 20.9221 3.4794 21.2918 2.6522 22.2444C1.6714 23.3738 2.5676 24.7511 1.7682 26.0555C1.244 26.9105 0 27.9221 0 27.9221C0 27.9221 1.249 29.0598 1.7682 29.9832C2.4742 31.2391 1.7703 32.4573 2.6522 33.561C3.4612 34.5733 5.5255 35.0776 5.5255 35.0776C5.5255 35.0776 3.8985 37.7312 3.9902 39.5887C4.1042 41.8992 6.1505 42.5545 6.9632 44.7221C7.4274 45.9598 7.602 46.6903 7.8462 47.9887Z",
    fill: "#FAD300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonYellowLeftLayer);
export default __webpack_public_path__ + "static/media/button-yellow-left-layer.8cf6d8b54c7a84af1fe25f2911607460.svg";
export { ForwardRef as ReactComponent };